import formModel from './formModel';

const {
    formField: {
        company_name,
        business_name,
        managerAffinity_mail,
        managerAffinity_name,
        managerAffinity_lastName,
        managerAffinity_phone,
        company_logo,
        intermediary_code,
        organizer_code,
        adviser_phone,
        assigned_advisers,
        activated_products,
        extra_discount,
        model_discount,
        business_unit,
        giftcard_amount,
        commercial_condition,
        commercial_description,
        statistic_group
    }
} = formModel;


export default {
    [company_name.name]: '',
    [company_logo.name]: null,
    [intermediary_code.name]: '',
    [organizer_code.name]: '',
    [assigned_advisers.name]: [],
    [business_name.name]:'',
    [managerAffinity_mail.name]:'',
    [managerAffinity_name.name]:'',
    [managerAffinity_lastName.name]:'',
    [managerAffinity_phone.name]:'',
    [adviser_phone.name]:'',
    [extra_discount.name]:0,
    [model_discount.name]:0,
    [activated_products.name]:["0"],
    [business_unit.name]: 1,
    [giftcard_amount.name]: 0,
    [commercial_condition.name]: "NO",
    [commercial_description.name]: "",
    [statistic_group.name]: "",
};
